'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_IngredientComponent$Props(stateSnapshot, unitOptions) {
  this.LK = null;
  this.LL = null;
  this.LK = stateSnapshot;
  this.LL = unitOptions;
}
export { $c_Lmealorama_components_IngredientComponent$Props as $c_Lmealorama_components_IngredientComponent$Props };
$p = $c_Lmealorama_components_IngredientComponent$Props.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_IngredientComponent$Props;
/** @constructor */
function $h_Lmealorama_components_IngredientComponent$Props() {
}
export { $h_Lmealorama_components_IngredientComponent$Props as $h_Lmealorama_components_IngredientComponent$Props };
$h_Lmealorama_components_IngredientComponent$Props.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 418637176, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_components_IngredientComponent$Props)) {
    var x = this.LK;
    var x$2 = x$0.LK;
    if (((x === null) ? (x$2 === null) : (x === x$2))) {
      var x$3 = this.LL;
      var x$4 = x$0.LL;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 2;
});
$p.r = (function() {
  return "Props";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.LK;
  }
  if ((n === 1)) {
    return this.LL;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_components_IngredientComponent$Props(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k8)));
}
export { $isArrayOf_Lmealorama_components_IngredientComponent$Props as $isArrayOf_Lmealorama_components_IngredientComponent$Props };
var $d_Lmealorama_components_IngredientComponent$Props = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_IngredientComponent$Props, "mealorama.components.IngredientComponent$Props", ({
  k8: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_components_IngredientComponent$Props as $d_Lmealorama_components_IngredientComponent$Props };
//# sourceMappingURL=mealorama.components.-Ingredient-Component$-Props.js.map
